import {setupNewTooltips} from "../modules/hover-tooltips";

document.addEventListener('DOMContentLoaded', () => {
    //setup new tooltips on load
    setupNewTooltips();
});